import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button } from '@mui/material';
/** Local styles */
const styles = {
    fontWeight: '500',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.00625rem',
    padding: '0.625rem 1.5rem',
    borderRadius: '100px',
    background: '#006B54',
    textTransform: 'none',
    color: '#FFFFFF',
};
;
/**
 * Customized Button
 * @param {ButtonProps} props
 * @returns {JSX.Element}
 */
export const ButtonSG = function (props) {
    let { xstyles } = props;
    if (!xstyles) {
        xstyles = {};
    }
    ;
    return (_jsx(Button
    // Customized button
    , Object.assign({ 
        // Customized button
        sx: Object.assign(Object.assign({}, styles), xstyles) }, props)));
};
